import Vue from 'vue'
import VueRouter from 'vue-router'

import Constants from '@/constants'
import routes from '@/routes'
import store from '@/store'

Vue.use(VueRouter)

const vueRouter = new VueRouter({
  mode: 'history',
  routes
})

vueRouter.beforeEach((to, _, next) => {
  if (to.matched.some(record => record.meta.requiresNullToken) && store.get('ApiModule/apiToken')) {
    next('/log-out')
  } else if (to.matched.some(record => record.meta.requiresToken) && !store.get('ApiModule/apiToken')) {
    next('/log-in')
  } else if (to.matched.some(record => record.meta.requiresClientStatus) && store.get('ApiModule/apiToken') && store.get('ApiModule/apiClient') && store.get('ApiModule/apiClient').status === Constants.STATUS_UNVERIFIED) {
    next('/verify-your-account')
  } else if (to.matched.some(record => record.meta.requiresProfessionalLocations) && store.get('ApiModule/apiToken') && store.get('ApiModule/apiProfessional') && store.get('ApiModule/apiProfessional').locations && store.get('ApiModule/apiProfessional').locations.length === 0) {
    next('/profile')
  } else if (to.matched.some(record => record.meta.requiresProfessionalPrices) && store.get('ApiModule/apiToken') && store.get('ApiModule/apiProfessional') && store.get('ApiModule/apiProfessional').prices && store.get('ApiModule/apiProfessional').prices.length === 0) {
    next('/profile')
  } else if (to.matched.some(record => record.meta.requiresProfessionalStatus) && store.get('ApiModule/apiToken') && store.get('ApiModule/apiProfessional') && store.get('ApiModule/apiProfessional').status === Constants.STATUS_UNVERIFIED) {
    next('/profile')
  } else if (to.matched.some(record => record.meta.requiresProfessionalWorkingHours) && store.get('ApiModule/apiToken') && store.get('ApiModule/apiProfessionalSlots') && store.get('ApiModule/apiProfessionalSlots').length === 0) {
    next('/working-hours')
  } else {
    next()
  }
})

export default vueRouter
